import { Action } from '@ngrx/store';
import { Reference } from '../../utils/action-helper.util';
import {
  Credentials,
  UserData,
  TokenAPI,
  ValidateTokenResponse,
  AppLoginInfoResponse,
  UserRegister,
} from '../_models/auth.models';
import { Error } from '../_models/auth.models';
import { environment } from 'src/environments/environment';

/**
 * Auth action types
 */
export enum AuthActionTypes {
  TOKEN = '[Auth] Token',
  TOKEN_SUCCESS = '[Auth] Token Success',
  TOKEN_FAILED = '[Auth] Token Failed',
  VALIDATE_TOKEN = '[Auth] Validate Token',
  VALIDATE_TOKEN_SUCCESS = '[Auth] Validate Token Success',
  VALIDATE_TOKEN_FAILED = '[Auth] Validate Token Failed',
  APP_LOGIN_INFO = '[Auth] App Login Info',
  APP_LOGIN_INFO_SUCCESS = '[Auth] App Login Info Success',
  APP_LOGIN_INFO_FAILED = '[Auth] App Login Info Failed',
  REGISTER_USER = '[Auth] Register User',
  REGISTER_USER_SUCCESS = '[Auth] Register User Success',
  REGISTER_USER_FAILED = '[Auth] Register User Failed',
  LOGIN_USER = '[Auth] Login User',
  LOGIN_USER_SUCCESS = '[Auth] Login User Success',
  LOGIN_USER_FAILED = '[Auth] Login User Failed',
  RESET = '[Auth] RESET',
}

/**
 * Operations
 */

export class Token implements Action {
  readonly type = AuthActionTypes.TOKEN;

  constructor(public payload: Credentials, public serverUrl: string = environment.apiUrl) {}
}

export class TokenSuccess implements Action {
  readonly type = AuthActionTypes.TOKEN_SUCCESS;

  constructor(public payload: TokenAPI) {}
}

export class TokenFailed implements Action {
  readonly type = AuthActionTypes.TOKEN_FAILED;

  constructor(public payload: Error) {}
}

export class ValidateToken implements Action {
  readonly type = AuthActionTypes.VALIDATE_TOKEN;

  constructor(public payload: string) {}
}

export class ValidateTokenSuccess implements Action {
  readonly type = AuthActionTypes.VALIDATE_TOKEN_SUCCESS;

  constructor(public payload: ValidateTokenResponse) {}
}

export class ValidateTokenFailed implements Action {
  readonly type = AuthActionTypes.VALIDATE_TOKEN_FAILED;

  constructor(public payload: Error) {}
}

export class AppLoginInfo implements Action {
  readonly type = AuthActionTypes.APP_LOGIN_INFO;

  constructor(public payload: string) {}
}

export class AppLoginInfoSuccess implements Action {
  readonly type = AuthActionTypes.APP_LOGIN_INFO_SUCCESS;

  constructor(public payload: AppLoginInfoResponse) {}
}

export class AppLoginInfoFailed implements Action {
  readonly type = AuthActionTypes.APP_LOGIN_INFO_FAILED;

  constructor(public payload: Error) {}
}

export class RegisterUser implements Action {
  readonly type = AuthActionTypes.REGISTER_USER;

  constructor(public payload: UserRegister) {}
}

export class RegisterUserSuccess extends Reference implements Action {
  readonly type = AuthActionTypes.REGISTER_USER_SUCCESS;

  constructor(public payload: any) {
    super();
  }
}

export class RegisterUserFailed extends Reference implements Action {
  readonly type = AuthActionTypes.REGISTER_USER_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class LoginUser implements Action {
  readonly type = AuthActionTypes.LOGIN_USER;

  constructor(public payload: Credentials) {}
}

export class LoginUserSuccess implements Action {
  readonly type = AuthActionTypes.LOGIN_USER_SUCCESS;

  constructor(public payload: any) {}
}

export class LoginUserFailed implements Action {
  readonly type = AuthActionTypes.LOGIN_USER_FAILED;

  constructor(public payload: Error) {}
}

export class Reset implements Action {
  readonly type = AuthActionTypes.RESET;

  constructor() {}
}

/**
 * Available types
 */
export type Actions =
  | Token
  | TokenSuccess
  | TokenFailed
  | ValidateToken
  | ValidateTokenSuccess
  | ValidateTokenFailed
  | AppLoginInfo
  | AppLoginInfoSuccess
  | AppLoginInfoFailed
  | RegisterUser
  | RegisterUserSuccess
  | RegisterUserFailed
  | LoginUser
  | LoginUserSuccess
  | LoginUserFailed
  | Reset;
